module.exports = __webpack_public_path__ + "img/scrm_ui_2.8f0c894d.png";